/*
 * @Author: Duanjiaojiao
 * @Date: 2023-03-14 10:13:38
 * @LastEditors: Duanjiaojiao
 * @LastEditTime: 2023-03-14 10:13:44
 * @Description:
 * @FilePath: /BM-Main/src/utils/directives/zpm.js
 * @props:
 */
import Vue from 'vue'
function setAttributes(element, attrs) {
  Object.keys(attrs).forEach((key) => {
    if (attrs[key]) {
      element.setAttribute(key, attrs[key])
    }
  })
}

function safeToString(value) {
  return value == null ? '' : value.toString()
}

const bindLegoInfo = (el, binding) => {
  const {
    sectionid = '',
    sortname = '',
    sortid = '',
    url = '',
    other = '',
    areaexposure = '',
    isdot = '',
    metric = '',
    info = '',
    backup = ''
  } = binding.value
  const zpm_attrs = {
    'zz-sectionid': sectionid,
    'zz-sortid': safeToString(sortid),
    'zz-sortname': sortname,
    'zz-url': url,
    'zz-other': other,
    'data-areaexposure': safeToString(areaexposure),
    'data-isdot': isdot,
    'data-metric': metric,
    'data-info': info,
    'lego-area-backup': areaexposure && JSON.stringify(backup),
    'zz-backup': JSON.stringify(backup)
  }
  // console.log('zpm_attrs: ', zpm_attrs);
  setAttributes(el, zpm_attrs)
}

Vue.directive('zpm', {
  componentUpdated: function(el, binding) {
    bindLegoInfo(el, binding)
  },
  bind: function(el, binding) {
    bindLegoInfo(el, binding)
  }
})
